import { LOCATION_CHANGE } from 'react-router-redux';

const INITIAL_ROUTING_STATE = {

};

const routingReducer = (state = INITIAL_ROUTING_STATE, action = {}) => {

    switch (action.type) {
        case LOCATION_CHANGE:
            return {
                ...state,
                locationBeforeTransition: state.locationAfterTransition,
                locationAfterTransition: action.payload
            };

        default:
            return state;

    }
};

export default routingReducer;
